import React from 'react'
import {
  AutomobileIcon,
  AutomobileInterestsIcon,
  BuildingTreeIcon,
  BusinessBuildingIcon,
  BusinessServicesIcon,
  CapitolIcon,
  CareIcon,
  CircuitryIcon,
  ClapperboardIcon,
  ConstructionCraneIcon,
  ConstructionIcon,
  ConsumerGoodsIcon,
  ContractIcon,
  DiceIcon,
  EducationIcon,
  EnergyIcon,
  FactoryFolderIcon,
  FinancialServicesIcon,
  FoodAndBeverageIcon,
  GamingIcon,
  GovernmentContractingIcon,
  GovernmentIcon,
  GraduationCapIcon,
  HandshakeIcon,
  HealthcareIcon,
  LeafMoleculeIcon,
  LifeSciencesIcon,
  ManufacturingIcon,
  MediaAndEntertainmentIcon,
  NonprofitIcon,
  OperatorIcon,
  PlaceSettingIcon,
  PrivateClubsIcon,
  PrivateEquityIcon,
  ProfessionalServicesIcon,
  RealEstateIcon,
  RestaurantIcon,
  RestaurantInterestsIcon,
  RetailIcon,
  RoboticArmIcon,
  ShoppingBagsIcon,
  ShoppingCartIcon,
  SolarArrayIcon,
  StethoscopeIcon,
  TechnologyIcon,
  TelecommunicationsIcon,
  TennisIcon,
  TreasuryIcon,
} from '@rsmus/myrsm-icons'
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag'

import { TagIconMap } from '../types'

const IndustriesIconMapper = () => {
  const userRedesignFeatureEnabled = useFeatureFlag('UserProfile_Redesign')
  const tagIconMap: TagIconMap = userRedesignFeatureEnabled
    ? {
        automotive: <AutomobileInterestsIcon />,
        'business-services': <BusinessServicesIcon />,
        construction: <ConstructionIcon />,
        'consumer-goods': <ConsumerGoodsIcon />,
        'education-us': <EducationIcon />,
        energy: <EnergyIcon />,
        'financial-services': <FinancialServicesIcon />,
        'food-beverage': <FoodAndBeverageIcon />,
        gaming: <GamingIcon />,
        'government-contracting': <GovernmentContractingIcon />,
        'government-us': <GovernmentIcon />,
        'health-care-us': <HealthcareIcon />,
        'life-sciences': <LifeSciencesIcon />,
        manufacturing: <ManufacturingIcon />,
        'media-entertainment': <MediaAndEntertainmentIcon />,
        nonprofit: <NonprofitIcon />,
        'private-clubs': <PrivateClubsIcon />,
        'private-equity': <PrivateEquityIcon />,
        'professional-services': <ProfessionalServicesIcon />,
        'real-estate': <RealEstateIcon />,
        restaurant: <RestaurantInterestsIcon />,
        retail: <RetailIcon />,
        'technology-industry': <TechnologyIcon />,
        telecommunications: <TelecommunicationsIcon />,
      }
    : {
        automotive: <AutomobileIcon />,
        'business-services': <BusinessBuildingIcon />,
        construction: <ConstructionCraneIcon />,
        'consumer-goods': <ShoppingCartIcon />,
        'education-us': <GraduationCapIcon />,
        energy: <SolarArrayIcon />,
        'financial-services': <TreasuryIcon />,
        'food-beverage': <PlaceSettingIcon />,
        gaming: <DiceIcon />,
        'government-contracting': <ContractIcon />,
        'government-us': <CapitolIcon />,
        'health-care-us': <StethoscopeIcon />,
        'life-sciences': <LeafMoleculeIcon />,
        manufacturing: <RoboticArmIcon />,
        'media-entertainment': <ClapperboardIcon />,
        nonprofit: <CareIcon />,
        'private-clubs': <TennisIcon />,
        'private-equity': <FactoryFolderIcon />,
        'professional-services': <HandshakeIcon />,
        'real-estate': <BuildingTreeIcon />,
        restaurant: <RestaurantIcon />,
        retail: <ShoppingBagsIcon />,
        'technology-industry': <CircuitryIcon />,
        telecommunications: <OperatorIcon />,
      }

  return tagIconMap
}

export default IndustriesIconMapper
